import type { Theme } from "@mui/material/styles";
import { alpha } from "@mui/material/styles";
import type { AppSx } from "../types";

export interface QueryEditorComponentStyles {
  probeActionsRow: AppSx;
  probeResultBox: AppSx;
  probeErrorAlert: AppSx;
  dslSection: AppSx;
}

export function buildQueryEditorComponentStyles(theme: Theme): QueryEditorComponentStyles {
  return {
    probeActionsRow: {
      display: "flex",
      flexDirection: { xs: "column", sm: "row" },
      alignItems: { sm: "center" },
      gap: 1,
    },
    probeResultBox: {
      mt: 1.5,
      border: "1px solid",
      borderColor: "divider",
      borderRadius: 1.5,
      p: 1,
      bgcolor: alpha(theme.palette.background.default, 0.35),
    },
    probeErrorAlert: {
      mt: 1,
    },
    dslSection: {
      display: "flex",
      flexDirection: "column",
      gap: 1.5,
    },
  };
}
